import React from 'react';
import { Tag } from '@onward-delivery/design';
import { itemStatusDisplay } from '../utils';

const ItemStatusCell = ({ row }) => {
    const display = itemStatusDisplay(row.original);
    if (!display) {
        return <span className="text-sm text-muted">-</span>;
    }
    return <Tag variant={display.tone}>{display.label}</Tag>;
};

export default ItemStatusCell;
